import React, { Component, KeyboardEvent, RefObject, createRef } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Layer, Stage, Transformer } from 'react-konva'
import { KonvaEventObject } from 'konva/lib/Node'
import {
  Transformer as HTMLTransformerElement
} from 'konva/lib/shapes/Transformer'
import { produce } from 'immer'
import { RootState } from '../../store'
import unitUtil from '../../utils/unit.util'
import ZoomProperty from './ZoomProperty'
import {
  resetSelectedElement,
  transformElement,
  dragElement,
  replaceSelectedElement,
  moveSelectedElement,
  moveElementLayerToBottom,
  moveElementLayerToTop,
  replaceElementText,
} from '../../views/LabelBuilder/LabelBuilder.slice'
import Card from '../Card'
import Grid from './Grid'
import Elements from './Elements'
import History from './History'

import Konva from "konva";


interface Props {
  transformerRef: RefObject<HTMLTransformerElement>
}

type CombinedProps = Props & ConnectedProps<typeof connector>


interface State {
  popupMenuVisible: boolean;
  menuPosition: { x: number; y: number };
  selectedShape: Konva.Rect | null;
}

class Template extends Component<CombinedProps, State> {

  layerRef = createRef<Konva.Layer>();

    // Style for each menu item
 menuItemStyle: React.CSSProperties = {
  padding: '10px 20px',
  cursor: 'pointer',
  backgroundColor: 'white',
  color: 'black',
  borderBottom: '1px solid #ddd',
};



  handleStageClick = (event: KonvaEventObject<MouseEvent>) => {
    const stageElement = event.target
    if (!stageElement) return
    const clickedOnEmpty = stageElement === stageElement.getStage()
    if (!clickedOnEmpty) return
    this.props.resetSelectedElement()
    const transformerNode = this.props.transformerRef.current
    if (!transformerNode) return
    transformerNode.nodes([])
  }

  handleElementClick = (event: KonvaEventObject<MouseEvent>) => {
    const element = event.currentTarget
    this.props.replaceSelectedElement(element)
    const { transformerRef } = this.props
    const transformerNode = transformerRef.current
    if (transformerNode) {
      transformerNode.nodes([element])
      const layer = transformerNode.getLayer()
      if (layer) {
        layer.batchDraw()
      }
    }
  }

  handleElementRightClick = (event: KonvaEventObject<PointerEvent>) => {
    console.log("right click here!")
    event.evt.preventDefault(); // Prevent default browser context menu
    const shape = event.target as Konva.Rect;

    const mousePos = {
      x: event.evt.clientX,
      y: event.evt.clientY,
    };

    this.setState({
      selectedShape: shape,
      popupMenuVisible: true,
      menuPosition: mousePos,
    });
  }

  onTextUpdate = (id: string, textNode: Konva.Text, newText: string) => {
    console.log('Konva Text Node:', textNode);
    console.log('Updated Text:', newText);
    console.log('ID:', id);

    // Perform actions with the Konva Text node and updated text
    // For example, update Redux state or perform other operations

    //this.props.replaceSelectedElement({
    //  ...this.props.selectedElement,
    //  text: newText,
    //});
    this.props.replaceElementText(id, newText)
  }

  handleElementTransform = (event: KonvaEventObject<MouseEvent>) => {
    this.props.transformElement(event.currentTarget)
  }

  handleElementDrag = (event: KonvaEventObject<MouseEvent>) => {
    this.props.dragElement(event.currentTarget)
  }

  handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    const { selectedElement } = this.props
    if (!selectedElement) return
    event.preventDefault()
    const movePoint = event.shiftKey ? 10 : 1
    switch (event.key) {
      case 'ArrowUp':
        this.props.moveSelectedElement(0, -movePoint)
        break;
      case 'ArrowDown':
        this.props.moveSelectedElement(0, movePoint)
        break;
      case 'ArrowLeft':
        this.props.moveSelectedElement(-movePoint, 0)
        break;
      case 'ArrowRight':
        this.props.moveSelectedElement(movePoint, 0)
        break;
      default:
        break;
    }
  }

  get stageStyle () {
    return {
      transform: `scale(${this.props.zoom})`,
      transformOrigin: '0 0',
      paddingBottom: '10px',
      paddingRight: '10px',
      width: 'fit-content'
    }
  }

  get stageWidth () {
    const { unit, width } = this.props.stage
    return unitUtil.unitToPixel(unit, width)
  }

  get stageHeight () {
    const { unit, height } = this.props.stage
    return unitUtil.unitToPixel(unit, height)
  }

  constructor(props: CombinedProps) {
    super(props)
    this.state = {
      popupMenuVisible: false,
      menuPosition: { x: 0, y: 0 },
      selectedShape: null,
    };
    console.log("entro al constructor")
    this.handleElementRightClick = this.handleElementRightClick.bind(this)
  }

  // Close popup without any action
  closePopup = () => {
    this.setState({ popupMenuVisible: false });
  };

  // Handle the pop-up action
  handleMoveAction = (action: string) => {
    console.log(action) 

    const { selectedShape } = this.state;

    if (!selectedShape) return;

    try {
      if (action === "top") {
        selectedShape.moveToTop(); 
        this.props.moveElementLayerToTop(selectedShape)
      } else if (action === "bottom") {
        selectedShape.moveToBottom();
        this.props.moveElementLayerToBottom(selectedShape)
      }
      this.layerRef.current?.batchDraw(); // Redraw the layer
    } catch (error) {
      console.error("Error moving shape: ", error);
    }

    this.setState({ popupMenuVisible: false });
  };

  handleTop = () => {
    console.log('Top clicked');
    this.handleMoveAction("top")
  };

  handleBottom = () => {
    console.log('Bottom clicked');
    this.handleMoveAction("bottom")
  };


  render () {
    const { popupMenuVisible, menuPosition } = this.state;
    console.log("value of popup:")
    console.log(popupMenuVisible)
    return (
      <Card
        flat={true}
        className="border border-gray-200 bg-gray-200 h-full pt-0 pb-1.5"
        background='third'>
        <div className='py-1.5 flex gap-1.5'>
          <ZoomProperty />
          <History />
        </div>
        <div tabIndex={1} onKeyDown={this.handleKeyDown}>
          <Stage
            width={this.stageWidth}
            height={this.stageHeight}
            style={this.stageStyle}
            onClick={this.handleStageClick}
            >
              <Grid stage={this.props.stage} />
              <Elements
                elements={this.props.elements}
                onElementClick={this.handleElementClick}
                onElementTransform={this.handleElementTransform}
                onElementDrag={this.handleElementDrag}
                onElementRightClick={this.handleElementRightClick}
                onTextUpdate={this.onTextUpdate} />
              <Layer id="transformer">
                <Transformer ref={this.props.transformerRef} />
              </Layer>
              {/* Pop-up Modal */}
          </Stage>
          {popupMenuVisible && (
              /*<Popup
                onClose={this.closePopup}
                onAction={this.handleMoveAction} // Handle move top or bottom
              />*/
              <div
        style={{
          position: 'absolute',
          top: menuPosition.y,
          left: menuPosition.x,
          backgroundColor: 'white',
          border: '1px solid black',
          padding: '10px',
          zIndex: 1000,
        }}
        onMouseLeave={this.closePopup}
      >
        <ul>
          <li
          style={this.menuItemStyle}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#60A5FA'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
          onClick={this.handleTop}>Bring Forward</li>
          <li
           style={this.menuItemStyle}
           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#60A5FA'}
           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
           onClick={this.handleBottom}>Send Backward</li>
        </ul>
      </div>
            )}
        </div>
      </Card>
    )
  }
}

function mapStateToProps (state: RootState) {
  const { labelBuilder } = produce(state, draft => draft)
  const { stage, elements, selectedElement } = labelBuilder.markup
  const { zoom } = labelBuilder.markup
  return { stage, elements, zoom, selectedElement }
}

const mapDispatchToProps = {
  resetSelectedElement,
  transformElement,
  dragElement,
  replaceSelectedElement,
  moveSelectedElement,
  moveElementLayerToBottom,
  moveElementLayerToTop,
  replaceElementText
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(Template)
